import type { Theme } from '@mui/material';

export const styles = {
  drawerNavigation: (theme: Theme) => ({
    '& .MuiDrawer-paper': {
      minWidth: '100%',
      maxWidth: '100%',

      [theme.breakpoints.up('sm')]: {
        minWidth: 350,
        maxWidth: 350,
      },
    },
  }),

  header: (theme: Theme) => ({
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }),

  surveyLogo: (theme: Theme) => ({
    maxHeight: '4.5rem',
    marginBottom: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
  }),
};
